import React, { Component } from 'react';

class Contact extends Component {
	render() {
		return (
			<div style={{ display: 'flex' }} id='contact'>
				<div className='column margin-around'>
					<p>PROGRES PLUS, s.r.o.,</p>
					<div style={{ margin: '14px 0' }}><address>Hollého 716/38, Senica 905 01</address></div>
					<p><a href='mailto:office@progresplus.eu'>office@progresplus.eu</a></p>
				</div>
				<div className='column margin-around'>
					<p>Riaditeľ a konateľ,</p>
					<p>Mario Hazucha</p>
					<p><a href='mailto:hazucha@progresplus.eu'>hazucha@progresplus.eu</a></p>
					<p><a href='tel:+421902907710'>Mob.: 0902 907 710</a></p>
				</div>
				<div className='column margin-around'>
					<p>Obchodný riaditeľ,</p>
					<p>Ing. Milan Škrabák</p>
					<p><a href='mailto:skrabak@progresplus.eu'>skrabak@progresplus.eu</a></p>
					<p><a href='tel:+421904335167'>Mob.: 0904 335 167</a></p>
				</div>
				<div className='column margin-around'>
					<p>Asistentka,</p>
					<p>Miriam Nemethova</p>
					<p><a href='mailto:nemethova@progresplus.eu'>nemethova@progresplus.eu</a></p>
					<p><a href='tel:+421903435088'>Mob.: 0903 435 088</a></p>
				</div>
			</div>
		);
	}
}

export default Contact;
